/**
 * 队列
 * @filename: Queue.js
 * @author: Mr Prince
 * @date: 2021-05-07 15:30:21
 */
import Queue from "./Queue";

export default Queue;
